import type { DeepReadonly } from 'ts-essentials';

/* eslint-disable-next-line no-restricted-imports */
import type { Store } from '@jane/shared/models';
import type { DeliveryValidation } from '@jane/shared/types';

export function minimumDeliveryOrder({
  discountedSubtotal,
  store,
  deliveryValidateData,
}: {
  deliveryValidateData?: DeliveryValidation;
  discountedSubtotal: number;
  store: DeepReadonly<Store>;
}) {
  if (!store.delivery) return true;
  else if (deliveryValidateData)
    return discountedSubtotal >= (deliveryValidateData?.minimum || 0);
  else return true;
}
